import { ControlPoint } from "./controlPoint";
import { ProprieteAffichee } from "./proprieteAffichee";


export class Sismograph {
  id = 0;
  equipementId = '';
  controlPointId = 0;
  controlPointName = '';
  siteId = 0;


  getProprietesAffichees() {
    let tab: ProprieteAffichee[] = [];
    tab.push(new ProprieteAffichee('equipementId', 'CONTROL_POINT.SERIAL_NUMBER'));
    tab.push(new ProprieteAffichee('controlPointName', 'CONTROL_POINT.CONTROL_POINT'));
    return tab;
  }



}
